module.exports = __webpack_public_path__ + "media/Video 122b.7447e401.mp4";